<template>
    <modal name="terms">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <h2 class="title_section">Politicas</h2>
                </div>
                <div class="col-md-12 col-sm-12 text_politicas">
                    <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                        Necessitatibus accusantium blanditiis error quasi provident laudantium debitis esse repellendus nostrum recusandae ea qu
                        ibusdam rem, dicta voluptates modi, minima ex libero placeat.
                    </p>
                    <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                        Necessitatibus accusantium blanditiis error quasi provident laudantium debitis esse repellendus nostrum recusandae ea qu
                        ibusdam rem, dicta voluptates modi, minima ex libero placeat.
                    </p>
                    <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                        Necessitatibus accusantium blanditiis error quasi provident laudantium debitis esse repellendus nostrum recusandae ea qu
                        ibusdam rem, dicta voluptates modi, minima ex libero placeat.
                    </p>
                     <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                        Necessitatibus accusantium blanditiis error quasi provident laudantium debitis esse repellendus nostrum recusandae ea qu
                        ibusdam rem, dicta voluptates modi, minima ex libero placeat.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12 text-center">
                    <a class="btn btn-info btn-aceptar">Aceptar</a>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
   
}
</script>


<style>
    .container > .row{
        margin-top: 30px;
        margin-left: 10px;
        margin-bottom: 30px;
    }
    .title_section{
        color: #3366CC;
        font-weight: bolder;
    }
    .text_politicas{
        color: #000;
    }
    .v--modal-box{
        width: 60% !important;
        margin: auto !important;
        left: 0px !important;
        height: 100% !important;
        top: 60px !important;
    }
    .btn-aceptar{
        width: 250px;
        background: #3366CC !important;
        color: #fff !important;
    }
    .btn-aceptar:hover{
        cursor: pointer;
    }
</style>


